import { render, staticRenderFns } from "./ProDChart.vue?vue&type=template&id=51c608da&scoped=true&"
import script from "./ProDChart.vue?vue&type=script&lang=js&"
export * from "./ProDChart.vue?vue&type=script&lang=js&"
import style0 from "./ProDChart.vue?vue&type=style&index=0&id=51c608da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c608da",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
